"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.giftShape = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sender = require("./sender.shape");

var _historyItem = require("./historyItem.shape");

var _product = require("./product.shape");

var _campaign = require("./campaign.shape");

var _shippingInfo = require("./shippingInfo.shape");

var _meeting = require("./meeting.shape");

var giftShape = _propTypes.default.shape({
  id: _propTypes.default.number,
  campaign: _campaign.campaignShape,
  history: _propTypes.default.arrayOf(_historyItem.historyItemShape),
  meeting: _meeting.meetingShape,
  product: _product.productShape,
  sentAs: _sender.senderShape,
  sentBy: _sender.senderShape,
  shippingInfo: _shippingInfo.shippingInfoShape,
  statusId: _propTypes.default.number,
  createdAt: _propTypes.default.string,
  meetingNotes: _propTypes.default.string
});

exports.giftShape = giftShape;